// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"c2e47880","73":"6077316a","86":"3c9641d1","207":"b1736199","326":"9e1eedcd","487":"0450af02","541":"60be9a26","971":"56da39b4"}[chunkId] + ".chunk.js";
};